import React from 'react';
import '../../styles/breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  actions?: React.ReactNode;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, actions }) => {
  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs__container">
        {items.map((item, index) => (
          <React.Fragment key={item.label}>
            {item.href ? (
              <a href={item.href} className="breadcrumbs__link">
                {item.label}
              </a>
            ) : (
              <span className="breadcrumbs__current">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span className="breadcrumbs__separator">&gt;</span>
            )}
          </React.Fragment>
        ))}
      </div>
      {actions && (
        <div className="breadcrumbs__actions">
          {actions}
        </div>
      )}
    </div>
  );
};
